import React from "react";

import { isNotificationEnabled } from "@formant/core/model/IBaseEvent";
import { IEvent } from "@formant/core/model/IEvent";
import { Icon } from "@formant/ui/component/common/Icon";

import { SeverityIcon } from "./SeverityIcon";

export interface IEventIconProps {
    event: IEvent;
    className?: string;
}

export function EventIcon(props: IEventIconProps) {
    const { event, className } = props;

    const notificationEnabled = isNotificationEnabled(event);

    switch (event.type) {
        case "intervention-request":
            return (
                <Icon
                    name="assistance"
                    className={className}
                    data-tooltip="Intervention"
                />
            );
        case "datapoint-event":
            return notificationEnabled ? (
                <SeverityIcon
                    severity={event.severity}
                    className={className}
                    data-tooltip="Event"
                />
            ) : (
                <Icon name="event" className={className} data-tooltip="Event" />
            );
        case "triggered-event":
            return notificationEnabled ? (
                <SeverityIcon
                    severity={event.severity}
                    className={className}
                    data-tooltip="Event"
                />
            ) : (
                <Icon name="event" className={className} data-tooltip="Event" />
            );
        case "device-online":
            return notificationEnabled ? (
                <SeverityIcon
                    severity={event.severity}
                    className={className}
                    data-tooltip="Event"
                />
            ) : (
                <Icon name="event" className={className} data-tooltip="Event" />
            );
        case "device-offline":
            return notificationEnabled ? (
                <SeverityIcon
                    severity={event.severity}
                    className={className}
                    data-tooltip="Event"
                />
            ) : (
                <Icon name="event" className={className} data-tooltip="Event" />
            );
        case "teleop-session-record":
            return (
                <Icon
                    name="teleop"
                    className={className}
                    data-tooltip="Teleoperation session"
                />
            );
        case "port-forwarding-session-record":
            return (
                <Icon
                    name="teleop"
                    className={className}
                    data-tooltip="Port forwarding session"
                />
            );
        case "command-request":
        case "command-response":
        case "command-delivery":
            return (
                <Icon
                    name="command"
                    className={className}
                    data-tooltip="Command"
                />
            );
        case "custom":
            return notificationEnabled && event.severity ? (
                <SeverityIcon
                    severity={event.severity}
                    className={className}
                    data-tooltip="Custom API Event"
                />
            ) : (
                <Icon
                    name="event"
                    className={className}
                    data-tooltip="Custom API Event"
                />
            );
        case "stateful":
            return notificationEnabled && event.severity ? (
                <SeverityIcon
                    severity={event.severity}
                    className={className}
                    data-tooltip="Stateful Event"
                />
            ) : (
                <Icon
                    name="event"
                    className={className}
                    data-tooltip="Stateful event"
                />
            );
        case "comment":
            return (
                <Icon
                    name="comment"
                    className={className}
                    data-tooltip="Comment"
                />
            );
        case "annotation":
            return (
                <Icon
                    name="annotation"
                    className={className}
                    data-tooltip="Annotation"
                />
            );
        case "task-summary":
            return (
                <Icon
                    name="task-summary"
                    className={className}
                    data-tooltip="Task Summary"
                />
            );
        case "system":
            return (
                <Icon
                    name="refresh"
                    className={className}
                    data-tooltip="System event"
                />
            );
        default:
            return null;
    }
}
